export default __webpack_public_path__ + "c9cc2ffd921d09425708431d03196c5e.webp";